import {
	fetchEventSource
} from '@microsoft/fetch-event-source'

export class TencentSSEClient {
	constructor() {
		this.controller = null
	}

	/**
	 * 连接SSE服务
	 * @param {Object} params - 请求参数
	 * @param {Function} onMessage - 消息回调
	 * @param {Function} onError - 错误回调
	 */
	async connect(params, onMessage, onError) {
		// 中止已有连接
		if (this.controller) {
			this.controller.abort()
		}
		this.controller = new AbortController()
		try {
			await fetchEventSource('https://wss.lke.cloud.tencent.com/v1/qbot/chat/sse', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(params),
				signal: this.controller.signal,
				onopen: async (response) => {
					if (response.ok) {
						console.log('SSE连接成功')
						return
					}
					throw new Error(`连接失败: ${response.status}`)
				},
				onmessage: (event) => {
					try {
						const data = JSON.parse(event.data)
						onMessage(data)
					} catch (e) {
						console.error('消息解析错误:', e)
					}
				},
				onclose: () => {
					onMessage({"type": "close",})
					console.log('SSE连接关闭')
				},
				onerror: (err) => {
					onError(err)
					throw err // 停止自动重试
				}
			})
		} catch (err) {
			if (err.name !== 'AbortError') {
				console.error('SSE连接异常:', err)
			}
		}
	}

	// 断开连接
	disconnect() {
		if (this.controller) {
			this.controller.abort()
			this.controller = null
		}
	}
}